import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';

function useCardStyles(props) {
  var padding = props.padding,
      rest = _objectWithoutPropertiesLoose(props, ["padding"]);

  var styleProps = _extends({
    borderWidth: 'border',
    borderColor: 'border-gray-200',
    backgroundColor: 'bg-white',
    borderRadius: 'rounded-lg',
    boxShadow: 'shadow-sm'
  }, rest);

  switch (padding) {
    case 'xs':
      styleProps.padding = ['py-1', 'px-2'];
      break;

    case 'sm':
      styleProps.padding = ['py-2', 'px-4'];
      break;

    case 'md':
      styleProps.padding = ['py-4', 'px-6'];
      break;

    case 'lg':
      styleProps.padding = ['py-6', 'px-8'];
      break;

    case 'xl':
      styleProps.padding = ['py-8', 'px-10'];
      break;

    default:
      styleProps.padding = padding;
      break;
  }

  return styleProps;
}

export default useCardStyles;
//# sourceMappingURL=styles.esm.js.map
